import { render, staticRenderFns } from "./WeightSkuForm.vue?vue&type=template&id=5f5c34b9&scoped=true"
import script from "./WeightSkuForm.vue?vue&type=script&lang=js"
export * from "./WeightSkuForm.vue?vue&type=script&lang=js"
import style0 from "./WeightSkuForm.vue?vue&type=style&index=0&id=5f5c34b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c34b9",
  null
  
)

export default component.exports